const shopifyUrl = 'https://monkeypaw-wares.myshopify.com'
const cartKey = 'monkeypaw-shopify-cart-id'
const accessToken = '864a2dd307d2fb3fe5aadd92120f5076'
const linesObject = `
  node {
    id
    quantity
    merchandise {
      ... on ProductVariant {
        id
        title
        image {
          url
        }
        selectedOptions {
          name
          value
        }
        product {
          id
          title
        }
      }
    }
    cost {
      amountPerQuantity {
        amount
      }
      compareAtAmountPerQuantity {
        amount
      }
      subtotalAmount {
        amount
      }
    }
  }
`

// function for creating a new cart
const createCart = async () => {
  try {
    const response = await fetch(`${shopifyUrl}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({
        query: `
          mutation {
            cartCreate(input: {}) {
              cart {
                id
                checkoutUrl
                createdAt
                cost {
                  subtotalAmount {
                    amount
                  }
                  totalAmount {
                    amount
                  }
                }
                lines(first: 200) {
                  edges {
                    ${linesObject}
                  }
                }
              }
            }
          }
        `,
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('Error creating cart:', error)
  }
}

// function for retrieving an existing cart
const retrieveCart = async (cartId) => {
  try {
    const response = await fetch(`${shopifyUrl}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({
        query: `
          query {
            cart(id: "${cartId}") {
              id
              checkoutUrl
              createdAt
              cost {
                subtotalAmount {
                  amount
                  currencyCode
                }
                totalAmount {
                  amount
                  currencyCode
                }
              }
              lines(first: 200) {
                edges {
                  ${linesObject}
                }
              }
            }
          }
        `,
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('Error creating cart:', error)
  }
}

// funtion for adding a line item to the cart
const addLineItems = async ({ cartId, lines }) => {
  try {
    const response = await fetch(`${shopifyUrl}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({
        query: `
          mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
            cartLinesAdd(cartId: $cartId, lines: $lines) {
              cart {
                id
                checkoutUrl
                createdAt
                cost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                }
                lines(first: 200) {
                  edges {
                    ${linesObject}
                  }
                }
              }
            }
          }
        `,
        variables: {
          cartId,
          lines,
        },
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('Error adding line item:', error)
  }
}

// funtion for updating a line item in the cart
const updateLineItems = async ({ cartId, lines }) => {
  try {
    const response = await fetch(`${shopifyUrl}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({
        query: `
          mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
            cartLinesUpdate(cartId: $cartId, lines: $lines) {
              cart {
                id
                checkoutUrl
                createdAt
                cost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                }
                lines(first: 200) {
                  edges {
                    ${linesObject}
                  }
                }
              }
            }
          }
        `,
        variables: {
          cartId,
          lines,
        },
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('Error adding line item:', error)
  }
}

// funtion for getting a collection from shopify
const getCollection = async ({ collectionId }) => {
  try {
    const response = await fetch(`${shopifyUrl}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({
        query: `
          query($collectionId: ID!) {
            collection(id: $collectionId) {
              products(first: 200) {
                nodes {
                  handle
                  title
                  availableForSale
                  featuredImage {
                    url
                    altText
                  }
                  selectedOrFirstAvailableVariant {
                    id
                    availableForSale
                    selectedOptions {
                      name
                      value
                    }
                    compareAtPriceV2 {
                      amount
                    }
                    priceV2 {
                      amount
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          collectionId,
        },
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('Error adding line item:', error)
  }
}

// funtion for getting a collection from shopify
const getProduct = async ({ handle }) => {
  try {
    const response = await fetch(`${shopifyUrl}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': accessToken,
      },
      body: JSON.stringify({
        query: `
          query($handle: String!) {
            product(handle: $handle) {
              handle
              title
              availableForSale
              options {
                name
                optionValues {
                  name
                }
              }
              featuredImage {
                url
                altText
              }
              images(first: 100) {
                nodes {
                  url
                  altText
                }
              }
              variants(first: 100) {
                nodes {
                  id
                  title
                  availableForSale
                  selectedOptions {
                    name
                    value
                  }
                  compareAtPriceV2 {
                    amount
                  }
                  priceV2 {
                    amount
                  }
                }
              }
              selectedOrFirstAvailableVariant {
                id
                availableForSale
                selectedOptions {
                  name
                  value
                }
                compareAtPriceV2 {
                  amount
                }
                priceV2 {
                  amount
                }
              }
              descriptionHtml
            }
          }
        `,
        variables: {
          handle,
        },
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error('Error adding line item:', error)
  }
}

// function for getting the cart from local storage or creating a new one
const getCart = async () => {
  // start with empty cart
  let formattedCart = null

  // check if cart exists in local storage
  const cartObject = window.localStorage.getItem(cartKey)

  // parse cart object
  const cartJson = JSON.parse(cartObject)
  let cartId = null

  if (cartJson && cartJson.id) {
    cartId = cartJson.id
  }

  const thirtyDays = 1000 * 60 * 60 * 24 * 30

  // check if existing checkout is older than 30 days
  const hasExpired = cartJson ? new Date().getTime() - parseInt(cartJson.date_created) > thirtyDays : true

  // if cart exists and is less than 30 days old, set cart state
  if (cartId && !hasExpired) {
    const cart = await retrieveCart(cartId)
    const cartData = cart && cart.data && cart.data.cart ? cart.data.cart : null

    formattedCart = cartData
  } else {
    const cart = await createCart()
    const cartData =
      cart && cart.data && cart.data.cartCreate && cart.data.cartCreate.cart ? cart.data.cartCreate.cart : null

    const objForLocalStorage = {
      id: cartData.id,
      date_created: new Date(cartData.createdAt).getTime(),
    }

    // set local storage value
    window.localStorage.removeItem(cartKey)
    window.localStorage.setItem(cartKey, JSON.stringify(objForLocalStorage))

    formattedCart = cartData
  }

  return formattedCart
}

// function for getting the total number of items in the cart
const getTotalCartItems = (cart) => {
  const cartLines = cart && cart.lines && cart.lines.edges ? cart.lines.edges : null

  if (!cartLines) {
    return 0
  }

  return cartLines.reduce((accumulator, obj) => {
    const quantity = obj && obj.node && obj.node.quantity ? obj.node.quantity : 0

    return accumulator + quantity
  }, 0)
}

// function for formatting money
const formatMoney = (price, multiplier = 1) => {
  const amount = parseFloat((price * multiplier).toFixed(2))
  let formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)

  // remove .00 for whole-dollar amounts
  formattedPrice = formattedPrice.replace('.00', '')

  // add USD to the end
  // formattedPrice = `${formattedPrice} USD`

  return formattedPrice
}

export { addLineItems, updateLineItems, getCollection, formatMoney, getProduct, getCart, getTotalCartItems }
